@if (token) {
  <div #chatbot class="w-100 position-relative" id="phx-chatbot">
  </div>
}
<!--<div class="overlay row {{open}}">-->
<!--  <img src="assets/img/2024-02_chatbot_animiert_v2.gif">-->
<!--  <p>Nutzen Sie Ihren Digitalen Assistenten für <strong>Verfallinformationen</strong>,-->
<!--    <strong>Verfügbarkeitsanfragen</strong>, <strong>Hersteller Lieferfähigkeiten</strong>,-->
<!--    <strong>Bestellungen</strong> oder zur <strong>Aufnahme von Nachlieferungen.</strong></p>-->
<!--</div>-->
